/* eslint-disable no-console */
import { LitElement } from 'lit-element';

export const buildProduct = element =>
  element.hasAttribute('product') && {
    id: element.getAttribute('product'),
    ...(element.hasAttribute('product-components') && {
      components: JSON.parse(element.getAttribute('product-components'))
    })
  };

export const resolveFromParentElement = (element, key) => {
  let offer;
  let ref = element;
  while (ref) {
    if (ref instanceof LitElement && ref.tagName.startsWith('OG-') && ref.hasAttribute(key)) {
      return ref;
    }
    ref = ref.nodeType === 11 ? ref.host : ref.parentNode;
  }
  if (!offer) {
    console.warn(`No OG parent element found that has attribute [${key}]`, element);
  }
  return offer;
};

export const resolveProduct = element => {
  let product = buildProduct(element);
  if (!product) {
    const offer = resolveFromParentElement(element, 'product');
    if (offer) {
      product = buildProduct(offer);
    }
  }
  return product;
};

export const withProduct = Base =>
  class extends Base {
    get product() {
      return resolveProduct(this);
    }
  };
